import * as React from "react";
import {
  TabProps as MUITabProps,
  Tab as MUITab,
  styled,
  Tooltip,
} from "@mui/material";

import {
  getCurrentSizeProfile,
  responsiveFontSize,
} from "@common/components/Typography/style";

type TabProps = MUITabProps & {
  tooltip?: string;
};

const TabContainer = styled(MUITab)(({ theme }) => ({
  "&.MuiButtonBase-root.MuiTab-root": {
    fontSize: getCurrentSizeProfile().small,
    ...responsiveFontSize(theme, "small"),
  },
  "&.MuiButtonBase-root.MuiTab-root.Mui-selected": {
    color: theme.palette.common.white,
    borderBottomColor: theme.palette.success.main,
  },
}));

const Tab = (props: TabProps) => {
  return (
    <Tooltip
      title={props.tooltip ?? ""}
      arrow
      slotProps={{
        popper: {
          popperOptions: {
            modifiers: [
              {
                name: "offset",
                options: {
                  offset: [0, -15],
                },
              },
            ],
          },
        }
      }}
    >
      <span>
        <TabContainer {...props}>{props.children}</TabContainer>
      </span>
    </Tooltip>
  );
};

export default Tab;
